module.exports = __webpack_public_path__ + "static/media/MATH 126.7286a3a3.jpg";